import {
  APIScopeDataCore,
  APIReferenceAttributes,
  ArdoqId,
  MergeReferenceApiResponse,
  RestoreChangePayload,
  APITagAttributes,
  APIScopeData,
} from '@ardoq/api-types';
import { ApiResponse } from './types';
import {
  createEntity,
  deleteEntity,
  updateEntity,
  fetchEntity,
  toRequestOptions,
  Method,
  fetchJson,
} from './api';
import { isArdoqError, Result } from '@ardoq/common-helpers';

type APIReferenceScopeData = APIScopeDataCore & {
  tags: APITagAttributes[];
  scopeComponents: ArdoqId[];
};

const scopedata = async (entityIds: string[]): ApiResponse<APIScopeData> => {
  const request = new Request(
    `/api/reference/scopedata`,
    toRequestOptions(Method.POST, { 'reference-ids': entityIds })
  );
  return fetchJson<APIReferenceScopeData>(request).then(
    (result): Result<APIScopeData> => {
      if (isArdoqError(result)) {
        return result;
      }
      return result;
    }
  );
};

const merge = ({
  mergedEntity,
  entityIdsToDelete,
}: {
  mergedEntity: APIReferenceAttributes;
  entityIdsToDelete: ArdoqId[];
}): ApiResponse<MergeReferenceApiResponse> => {
  const request = new Request(
    `/api/reference/${mergedEntity._id}/merge`,
    toRequestOptions(Method.PUT, {
      'subsumed-reference-ids': entityIdsToDelete,
      'merged-reference-data': mergedEntity,
    })
  );
  return fetchJson<MergeReferenceApiResponse>(request);
};

const restore = async (
  payload: RestoreChangePayload
): ApiResponse<APIReferenceAttributes> => {
  const entityAttributes = await referenceApi.fetch(payload.entityId);
  if (isArdoqError(entityAttributes)) {
    return entityAttributes;
  }
  return referenceApi.updateReference({
    ...entityAttributes,
    [payload.fieldName]: payload.restorableValue,
  });
};

type ReferenceTypesSortedByMostUsedPayload = {
  source: APIReferenceAttributes['source'];
  target: APIReferenceAttributes['target'];
  rootWorkspace: APIReferenceAttributes['rootWorkspace'];
  targetWorkspace: APIReferenceAttributes['targetWorkspace'];
};

const getReferenceTypesSortedByMostUsed = (
  payload: ReferenceTypesSortedByMostUsedPayload
): ApiResponse<{ sortedByMostUsedRefTypes: string[] }> => {
  const request = new Request(
    `/api/reference/sorted-type-suggestions`,
    toRequestOptions(Method.POST, payload)
  );

  return fetchJson<{ sortedByMostUsedRefTypes: string[] }>(request);
};

export const referenceApi = {
  create: createEntity<APIReferenceAttributes>('reference'),
  delete: deleteEntity('reference'),
  updateReference: updateEntity<APIReferenceAttributes>('reference'),
  fetch: fetchEntity<APIReferenceAttributes>('reference'),
  scopedata,
  merge,
  restore,
  getReferenceTypesSortedByMostUsed,
};
